import { useEffect, useState } from 'react';

export default function useVolumeButtons(onTrigger, isEnabled = true) {
  const [hasUsedVolume, setHasUsedVolume] = useState(false);

  useEffect(() => {
    if (!isEnabled) return;

    const handleKeyPress = (event) => {
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown' || 
          event.keyCode === 175 || event.keyCode === 174 || 
          event.keyCode === 38 || event.keyCode === 40) {
        event.preventDefault();
        setHasUsedVolume(true);
        onTrigger();
      }
    };

    const handleMediaButton = (event) => {
      event.preventDefault();
      setHasUsedVolume(true);
      onTrigger();
    };

    window.addEventListener('keyup', handleKeyPress);
    window.addEventListener('mediabutton', handleMediaButton);

    if (navigator.mediaSession) {
      navigator.mediaSession.setActionHandler('previoustrack', handleMediaButton);
      navigator.mediaSession.setActionHandler('nexttrack', handleMediaButton);
    }

    return () => {
      window.removeEventListener('keyup', handleKeyPress);
      window.removeEventListener('mediabutton', handleMediaButton);
      if (navigator.mediaSession) {
        navigator.mediaSession.setActionHandler('previoustrack', null);
        navigator.mediaSession.setActionHandler('nexttrack', null);
      }
    };
  }, [onTrigger, isEnabled]);

  return { hasUsedVolume };
}